function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.886 19.845l-5.245-8.613a.75.75 0 00-1.282 0l-.724 1.188-2.104-3.786a.749.749 0 00-.28-.285V6.565l3.533-1.01a.318.318 0 000-.612l-3.534-1.01V3.75a.75.75 0 00-1.5 0v4.598a.748.748 0 00-.277.28L3.098 19.873a.75.75 0 00.652 1.12c8.154-.015 12.276-.003 14.387.004 2.085.006 2.21.006 2.32-.032a1.201 1.201 0 00.041-.014.75.75 0 00.388-1.106zM10.497 9.862l1.604 2.884H8.862l1.635-2.885zm2.437 4.383H8.012l-2.975 5.248h13.879L15 13.063l-.527.865.808 1.453a.75.75 0 11-1.311.728L12.965 14.3a.766.766 0 01-.03-.052l-.001-.004z",
  clipRule: "evenodd"
}));